import { apolloApi } from "@/shared/api";
import { useAsync } from "./useAsync";

export interface PersonnelCacheItem {
  type: "personnel";
  key: string;
  id: number;
  fullName: string;
  display: string;
}

type PersonnelMap = Map<string, PersonnelCacheItem>;
let PERSONNEL_MAP: PersonnelMap | undefined;
let PERSONNEL_LIST_PROMISE: Promise<PersonnelMap> | null = null;

export function usePersonnelMap() {
  return useAsync(async () => {
    if (PERSONNEL_MAP) {
      return PERSONNEL_MAP;
    }

    if (PERSONNEL_LIST_PROMISE) {
      return PERSONNEL_LIST_PROMISE;
    }

    PERSONNEL_LIST_PROMISE = apolloApi
      .getAllPersonnel({})
      .then((response) => {
        PERSONNEL_MAP = new Map<string, PersonnelCacheItem>();
        response.personnel.sort(sortPersonnel).forEach((personnel) => {
          PERSONNEL_MAP!.set(`personnel-${personnel.id}`, {
            type: "personnel",
            key: `personnel-${personnel.id}`,
            id: personnel.id,
            fullName: personnel.firstName + " " + personnel.lastName,
            display: personnel.lastName + ", " + personnel.firstName,
          });
        });

        return PERSONNEL_MAP;
      })
      .finally(() => {
        PERSONNEL_LIST_PROMISE = null;
      });

    return PERSONNEL_LIST_PROMISE;
  });
}

interface Personnel {
  firstName: string;
  lastName: string;
}

function sortPersonnel(personnel1: Personnel, personnel2: Personnel) {
  const lastNameComparison = personnel1.lastName.localeCompare(
    personnel2.lastName
  );
  if (lastNameComparison != 0) {
    return lastNameComparison;
  }
  return personnel1.firstName.localeCompare(personnel2.firstName);
}
